var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-10 mx-auto" }, [
          _c("div", { staticClass: "row justify-content-center mb-4" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "div",
                  { staticClass: "m-b-30" },
                  _vm._l(_vm.dataListMarketplace, function(marketplace, idx) {
                    return _c(
                      "ul",
                      { key: idx, staticClass: "list-group notification-list" },
                      [
                        _c("li", { staticClass: "list-group-item" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.marketplaceIcon(marketplace)
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "status-toggle" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formMPId[idx],
                                  expression: "formMPId[idx]"
                                }
                              ],
                              ref: "mp_" + marketplace,
                              refInFor: true,
                              staticClass: "check",
                              attrs: {
                                id: "mp_" + marketplace,
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.formMPId[idx])
                                  ? _vm._i(_vm.formMPId[idx], null) > -1
                                  : _vm.formMPId[idx]
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.formMPId[idx],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.formMPId,
                                            idx,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.formMPId,
                                            idx,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.formMPId, idx, $$c)
                                    }
                                  },
                                  function($event) {
                                    return _vm.updateOrDelete(marketplace, idx)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "checktoggle",
                                attrs: { for: "mp_" + marketplace }
                              },
                              [_vm._v("checkbox")]
                            )
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3268e403", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3268e403","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/scrape/components/form2.vue
// module id = null
// module chunks = 